import React from 'react';

import {
  Icon,
  Button,
  Dropdown,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

function getPages(page: number, count: number) {
  const left = count > 5 ? count - 4 : 1;
  const right = (page + 2 < count) ? page - 2 : left;

  return Array
    .from({
      length: count > 5 ? 5 : count,
    },
    (v, k) => k + (page > 3 ? right : 1));
}

type Props = {
  count: number,
  current: number,
  goToPage: { (page: number): void },
};

const Pagination = ({
  current,
  count,
  goToPage,
}: Props) => {
  const pages = getPages(current, count);

  return (
    <Flex padding="15px" spacing={6}>
      {count > 5 && (
        <Button
          ghost
          onClick={() => {
            goToPage(1);
          }}
          spacing="compact"
          appearance="primary"
          isDisabled={current < 2}
        >
          {'<<'}
        </Button>
      )}
      <Button
        ghost
        onClick={() => {
          goToPage(current - 1);
        }}
        spacing="compact"
        appearance="primary"
        isDisabled={current < 2}
      >
        {'<'}
      </Button>

      {pages.map(page => (current !== page ? (
        <Button
          key={`page-${page}`}
          spacing="compact"
          appearance="primary"
          onClick={() => {
            goToPage(page);
          }}
          ghost
        >
          {page}
        </Button>
      ) : (
        <Dropdown
          key={`page-${page}`}
          place="above"
          minWidth="20px"
          trigger={(
            <Button
              spacing="compact"
              appearance="primary"
            >
              {`${page} `}
              <Icon type="fas fa-chevron-down" />
            </Button>
          )}
          items={
            Array
              .from({ length: count })
              .map(
                (v, k) => ({
                  name: k + 1,
                  onClick: () => goToPage(k + 1),
                }),
              )
          }
        />
      )))}

      <Button
        ghost
        onClick={() => {
          goToPage(current + 1);
        }}
        spacing="compact"
        appearance="primary"
        isDisabled={current >= count}
      >
        {'>'}
      </Button>
      {count > 5 && (
        <Button
          ghost
          onClick={() => {
            goToPage(count);
          }}
          spacing="compact"
          appearance="primary"
          isDisabled={current >= count}
        >
          {'>>'}
          {count}
        </Button>
      )}
    </Flex>
  );
};

export default Pagination;
